import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

export const SUPPORTED_LANGUAGES = ['es', 'eu'];
export const DEFAULT_LANGUAGE = 'es';

import es from './locales/es.json';
import eu from './locales/eu.json';

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: DEFAULT_LANGUAGE,
        supportedLngs: SUPPORTED_LANGUAGES,
        detection: {
            order: ['path', 'localStorage', 'navigator'],
            lookupFromPathIndex: 0,
            caches: ['localStorage'],
        },
        resources: {
            es: { translation: es },
            eu: { translation: eu },
        },
        interpolation: { escapeValue: false },
    });

export default i18n;
